// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.buildingsCard {\n    height: 50px;\n}\n.parameter-card {\n    background: linear-gradient(0deg, rgba(34, 193, 195, 1) 0%, rgba(1, 84, 166, 1) 100%);\n}\n.v-card--link {\n    cursor: default;\n}\n.v-slide-group.v-item-group > .v-slide-group__next,\n.v-slide-group.v-item-group > .v-slide-group__prev {\n    margin-left: -10px;\n    cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
